import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { movies } from "@/mocks/movies";
import SectionHeading from "@/components/feature/SectionHeading";

export default function CategoryGrid() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
      <SectionHeading
        eyebrow="Browse by Genre"
        title="按类型找电影"
        description="八大类型覆盖从热血动作到温情纪录，点击即可浏览对应分类下的精选影片。"
      />
      <div className="grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-4">
        {categories.map((category) => {
          const count = movies.filter((movie) => movie.genres.includes(category.key)).length;
          return (
            <Link
              key={category.key}
              to={`/category/${category.key}`}
              className="group flex flex-col gap-3 rounded-lg border border-background-200/60 bg-background-100 p-4 transition-colors hover:border-primary-400/60 hover:bg-background-200/50 md:p-5"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-100 text-primary-400 transition-colors group-hover:bg-primary-500 group-hover:text-foreground-950">
                  <i className={`${category.icon} text-xl`} />
                </span>
                <span className="font-label text-xs text-foreground-500">{count} 部</span>
              </div>
              <div>
                <h3 className="font-heading text-base font-bold text-foreground-50 group-hover:text-primary-400">
                  {category.name}片
                </h3>
                <p className="mt-1 hidden text-xs leading-relaxed text-foreground-400 sm:block">{category.desc}</p>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}